<template>
  <div>
    <h1 class="title">{{ $t("workspace.members") }}</h1>
    <div class="breadcrumb-new"></div>

    <div class="table-responsive mb-0" v-if="pagination && pagination.docs.length > 0">
      <table class="table table-centered table-nowrap">
        <tbody>
          <tr v-for="item in pagination.docs" :key="item._id" class="hider">
            <td>
              <span v-if="item && item.account.credential">
                <span v-b-tooltip.hover :title="$t('common.active')" v-if="item.account.credential.active"><i class="bx bxs-circle text-success"></i> </span>
                <span v-b-tooltip.hover :title="$t('common.passive')" v-else="item.account.credential.active"><i class="bx bxs-circle text-danger"></i> </span>
              </span>
            </td>
            <td style="width: 50px;">
              <letter-avatar :name="item.name" :image="item.logo" variant="secondary"> </letter-avatar>
            </td>
            <td>
              <h5 class="font-size-14 m-0">
                {{ item.name }}
              </h5>
              <h5 class="font-size-14 m-0 mt-1">
                {{ item.email }}
              </h5>
            </td>
            <td>
              <multiselect
                :value="memberRole(item)"
                track-by="definition"
                :placeholder="$t('workspace.role')"
                :options="workspaceRoles"
                :searchable="false"
                :allow-empty="false"
                :show-labels="false"
                @select="memberRoleSelected($event, item)"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <b> <i class="mdi mdi-account-circle"></i> {{ option.name | translate }} </b>

                    <div v-html="$options.filters.translate(option.description)"></div>
                  </div>
                </template>
                <template slot="option" slot-scope="{ option }">
                  <b> <i class="mdi mdi-account-circle"></i> {{ option.name | translate }} </b>
                  <div v-html="$options.filters.translate(option.description)"></div>
                </template>
              </multiselect>
            </td>
            <td>
              <i
                v-if="item.edited"
                class="mdi mdi-check-bold text-success hand"
                v-b-tooltip.hover
                :title="$t('common.save')"
                @click="updateMemberWorkspaceRole(item)"
                style="font-size: 18px; "
              ></i>
            </td>

            <td class="text-left">
              <i
                class="bx bx-trash-alt text-danger hand  mr-3"
                v-b-tooltip.hover
                :title="$t('common.delete')"
                @click="removeMember(item)"
                style="font-size: 18px; margin-top: 6px;"
              ></i>
              <i
                v-if="item.account && item.account.credential && !item.account.credential.active"
                class="bx bx-check-double text-success hand"
                v-b-tooltip.hover
                @click="activate(item)"
                :title="$t('account.activation-activate2')"
                style="font-size: 18px; margin-top: 6px;"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center mt-auto">
        <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10"></b-pagination>
      </div>
      <button class="button" @click="showInviteModal">
        <b>{{ $t("common.invite") }}</b>
      </button>
    </div>

    <div class="backdrop2" :class="{ active: isShow }" @click="closeModal">
      <div class="modal2" style="max-width: 50rem;" @click.stop>
        <div class="d-flex flex-column justify-content-center align-items-center mb-4">
          <i class="modal--icon iconoir-send-mail"></i>
          <h6 class="modal--title">{{ $t("workspace.invite-text") }}</h6>
          <small>{{ $t("workspace.can-invite") }}</small>
        </div>
        <sweet-button
          v-if="!showInviteForm && !showBulkInviteForm"
          @click="showInviteForm = true"
          :loading="isUpdating"
          variant="link"
          icon="bx bx-plus"
          size="sm"
          buttonClass="mt-1"
        >
          {{ $t("workspace.invite-a-user-to-workspace") }}
        </sweet-button>

        <sweet-button
          v-if="!showInviteForm && !showBulkInviteForm"
          @click="showBulkInviteForm = true"
          :loading="isUpdating"
          variant="link"
          icon="bx bx-plus"
          size="sm"
          buttonClass="mt-1"
        >
          {{ $t("workspace.import-users") }}
        </sweet-button>

        <div v-if="isShow">
          <div v-if="showInviteForm">
            <hr />
            <WorkspaceInviteMember :workspace="workspace" @onSent="paginate()" ref="workspaceInviteMember" @closeModal="closeModal()" />
          </div>
          <div v-else-if="showBulkInviteForm">
            <hr />

            <h5 class="mt-4">{{ $t("workspace.invite-users-to-workspace") }}</h5>
            <div class="card card-body">
              <WorkspaceBulkInvite :workspace="workspace" @onSent="paginate()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import WorkspaceBulkInvite from "./workspace-bulk-invite";
import WorkspaceInviteMember from "./workspace-invite-member";

export default {
  components: {
    WorkspaceInviteMember,
    WorkspaceBulkInvite,
  },

  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
      editMode: false,
      showInviteForm: false,
      nameFilter: undefined,
      showBulkInviteForm: false,
      form: { _id: undefined, name: undefined },
      formError: undefined,
      isDisable: false,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(30),
      },
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.paginate());
      },
    },

    isShow: {
      immediate: true,
      handler() {
        this.showInviteForm = false;
        this.showBulkInviteForm = false;
      },
    },
  },
  computed: {
    memberRole() {
      return (item) => {
        const workspaceRole = this.$store.getters["workspace/roleByMemberId"](item._id);
        return workspaceRole;
      };
    },
    isUpdating() {
      return this.$store.getters["workspace/isUpdating"];
    },
    workspace() {
      return this.$store.getters["switchWorkspace/selected"];
    },
    pagination() {
      return this.$store.getters["workspace/paginationMember"];
    },
    loading() {
      return this.$store.getters["workspace/isLoading"];
    },
    workspaceRoles() {
      return this.$store.getters["workspaceRole/roles"];
    },
    isShow() {
      return this.$store.getters["workspace/showInviteModal"];
    },
  },
  mounted() {},
  methods: {
    async updateMemberWorkspaceRole(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("workspace/updateMemberWorkspaceRole", {
          workspace: this.workspace,
          member: { _id: item._id },
          workspaceRole: item.workspaceRole,
        });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
      }
      this.markAsEdited(item, false);
      this.$forceUpdate();
    },
    async activate(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("workspace/activateMember", item._id);
        this.$toast.success(this.$t("common.successful"));
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async removeMember(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("workspace/removeMember", item._id);
        this.$toast.success(this.$t("common.delete-successful"));
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    memberRoleSelected(role, member) {
      this.markAsEdited(member, true);
      this.$store.commit("workspace/memberRole", { member, role });
    },
    markAsEdited(member, edited) {
      this.$store.commit("workspace/memberEdited", { member, edited });
    },
    paginate() {
      this.$store.dispatch(`workspace/paginateMember`, { pagination: this.request, id: this.workspace?._id });
    },

    closeModal() {
      this.$store.commit("workspace/showInviteModal", false);
    },
    showInviteModal() {
      this.$store.commit("workspace/showInviteModal", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./workspace-members.scss");
</style>
